import { render } from "./section-item-detail.vue?vue&type=template&id=44fb9d24&ts=true"
import script from "./section-item-detail.vue?vue&type=script&lang=ts"
export * from "./section-item-detail.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__